import React from 'react';
import { array, bool, number, object } from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { I18n } from '@fiverr-private/fiverr_context';
import { Button } from '@fiverr-private/fit';
import { getPackageById, isRecurringGig } from '../../../reducers/packages';
import { selectPackage } from '../../../actions/packages';

import './style.scss';

const SelectButton = ({ currentPrice, inProgress, onClick }, { currencyConverter, general }) => {
    const formattedPrice = currencyConverter.convert(currentPrice);
    const btnColor = general.isPro ? Button.COLORS.BLACK : Button.COLORS.GREEN;

    /* this visually disables the button, but doesn't actually disable it */
    const btnClasses = classNames(
        'btn-select-package',
        { 'button-disabled': inProgress }
    );

    return (
        <>
            <p className="price-label">{formattedPrice}</p>
            <Button type="submit" className={btnClasses} color={btnColor} onClick={onClick}>
                <I18n k={'gig_page_perseus.packages_table.select'}/>
            </Button>
        </>
    );
};

SelectButton.propTypes = {
    currentPrice: number
};

SelectButton.contextTypes = {
    currencyConverter: object,
    general: object
};

SelectButton.defaultProps = {
    onClick: () => true
};

const mapStateToProps = ({ packages }, ownProps) => {
    const packageData = getPackageById(packages, ownProps.id);

    return {
        currentPrice: packageData.currentPrice,
        inProgress: packages.selectedPackageId === ownProps.id
    };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
    onClick: () => {
        dispatch(selectPackage({ packageId: ownProps.id }));
    }
});

const SelectButtonConnect = connect(mapStateToProps, mapDispatchToProps)(SelectButton);

const SelectPackage = ({ packageList, isRecurringGig = false }) => {
    const showTotalTitle = !isRecurringGig;

    return (
        <tr className="select-package">
            <th>
                {showTotalTitle && <I18n k={'gig_page_perseus.packages_table.total'}/>}
            </th>
            {packageList.map(({ id }) => (
                <td key={id}>
                    <SelectButtonConnect id={id}/>
                </td>
            ))}
        </tr>
    );
};

SelectPackage.propTypes = {
    packageList: array,
    isRecurringGig: bool
};

const mapSelectPackageStateToProps = ({ packages }) => {
    const { packageList } = packages;

    return {
        packageList,
        isRecurringGig: isRecurringGig(packages)
    };
};

export { SelectPackage, SelectButton };
export default connect(mapSelectPackageStateToProps)(SelectPackage);
